import { render, staticRenderFns } from "./DeleteInvoiceButton.vue?vue&type=template&id=8b4ff8c2&scoped=true&"
import script from "./DeleteInvoiceButton.vue?vue&type=script&lang=js&"
export * from "./DeleteInvoiceButton.vue?vue&type=script&lang=js&"
import style0 from "./DeleteInvoiceButton.vue?vue&type=style&index=0&id=8b4ff8c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4ff8c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b4ff8c2')) {
      api.createRecord('8b4ff8c2', component.options)
    } else {
      api.reload('8b4ff8c2', component.options)
    }
    module.hot.accept("./DeleteInvoiceButton.vue?vue&type=template&id=8b4ff8c2&scoped=true&", function () {
      api.rerender('8b4ff8c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/CustomerInvoices/buttons/DeleteInvoiceButton.vue"
export default component.exports